export class ContactBillingInternalEmail {
  constructor(
    public firstName: string,
    public lastName: string,
    public prefferedContactReason: string,
    // public address: string,
    // public city: string,
    // public state:string,
    // public zipCode:Number,
    public prefferedContactMode: string,
    public email: string,
    public phone: string,
    public billAccountNumber: string,
    public comment: string,
    public accountType: string
  ) {}
}
